import DeprecatedApiClient from '../../../packages/neb-api-client/src/utils/api-client-utils';

export const BASE_URL = 'booking/billing-address';

export const billingApiClient = new DeprecatedApiClient({
  microservice: 'billing',
});

export const getBookingBillingAddress = () =>
  billingApiClient.makeRequest({
    optOutLoadingIndicator: false,
    path: BASE_URL,
    version: 1,
    cacheKey: 'booking-billing-address',
  });
